require('./customViewOption.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const ClassNames = require('classnames');

// @components
const { OKLink } = require('commonsComponents/OKLink');

// @ constants
const { BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW } = require('constants/index');

class customViewOption extends React.Component {

    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
    }

    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option);
    }

    render() {
        const { isFocused, option } = this.props;
        let optionElement;

        if (!option.isLink) {

            const optionsClass = ClassNames(
                'custom-view-option__results-item', {
                'custom-view-option__results-item--focus': isFocused
            });

            optionElement = (
                <div className={optionsClass}
                    onMouseDown={this.handleMouseDown}
                    >
                    {option.label}
                </div>
            );

        } else { 
            optionElement = (
                <div className="custom-view-option__show-more-link" >
                    <OKLink modifier="emphasize" to={BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW}>
                        <FormattedText value="brokerCustomWallet-configureNewView" />
                    </OKLink>
                </div>
            );
        }
        return optionElement;
    }
}

customViewOption.propTypes = {
    option: PropTypes.object.isRequired,
    isFocused: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};

module.exports = customViewOption;